module.exports = __webpack_public_path__ + "img/coastal-logo.bbd63d0c.jpg";